import React from "react";
import { Input, Label } from "reactstrap";
import { useSelector } from "react-redux";

const FileInput = ({
  multiple,
  label,
  readonly,
  handlePictureChange,
  previews,
  handleRemoveImage,
  fieldLoaders,
  ...props
}) => {
  // Handle broken image URLs gracefully
  const handleError = (e) => {
    const img = e.target;
    if (!img.dataset.triedFallback) {
      const originalSrc = img.src;
      const url = new URL(originalSrc);
      img.src = `${process.env.REACT_APP_IMAGE_API_URL2}${url.pathname}`;
      img.dataset.triedFallback = true;
    }
  };

  const imageloader = useSelector((state) => state.globalslice.imageloader);

  // File type detectors
  const isPdf = (fileUrl) => fileUrl?.toLowerCase().endsWith(".pdf");
  const isVideo = (fileUrl) =>
    /\.(mp4|mov|avi|webm|mkv|m4v)$/i.test(fileUrl || "");

  // Get a trimmed file name for PDFs
  const getFileName = (url) => {
    try {
      const name = url.split("/").pop();
      return name.length > 20 ? name.slice(0, 17) + "..." : name;
    } catch {
      return "document.pdf";
    }
  };

  return (
    <>
      {label && (
        <Label htmlFor="formFileMultiple" className="form-label">
          {label}
        </Label>
      )}

      <Input
        className="form-control form-control-sm"
        name={props.name}
        type="file"
        id="formFileMultiple"
        multiple={multiple}
        disabled={readonly}
        onChange={handlePictureChange}
        accept="image/*,video/*,.pdf"
      />

      {/* PREVIEWS SECTION */}
      <div
        style={{
          display: "flex",
          gap: "1rem",
          marginTop: "1rem",
          flexWrap: "wrap",
        }}
      >
        {previews?.map(
          (file, index) =>
            file.file_status !== "delete" && (
              <div
                key={index}
                style={{
                  position: "relative",
                  width: "150px",
                  height: "100px",
                }}
              >
                {/* File Preview */}
                <a
                  href={file.file_url}
                  // target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {isPdf(file.file_url) ? (
                    <div
                      style={{
                        width: "150px",
                        height: "100px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f8f8f8",
                        fontSize: "10px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      {getFileName(file.file_url)}
                    </div>
                  ) : isVideo(file.file_url) ? (
                    <video
                      src={file.file_url}
                      controls
                      style={{
                        width: "150px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        background: "#000",
                      }}
                    />
                  ) : (
                    <img
                      onError={handleError}
                      src={file.file_url}
                      alt={`preview-${index}`}
                      style={{
                        width: "150px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        background: "#f8f8f8",
                      }}
                    />
                  )}
                </a>

                {/* Remove Button */}
                {!readonly && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemoveImage(props.name, index);
                    }}
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      cursor: "pointer",
                      width: "22px",
                      height: "22px",
                      fontSize: "14px",
                      lineHeight: "18px",
                      textAlign: "center",
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            )
        )}
      </div>

      {/* Field Loader */}
      {fieldLoaders && (
        <div className="spinner-border spinner-border-sm" role="status"></div>
      )}
    </>
  );
};

export default FileInput;
